export interface NotificationSettingListResponse {
  id: string
  path: string
  label: string
  enabled: boolean
}

export class NotificationSettingListModel {
  public id: string
  public path: string
  public label: string
  public enabled: boolean

  public constructor(data: NotificationSettingListResponse) {
    this.id = data.id
    this.path = data.path
    this.label = data.label
    this.enabled = data.enabled
  }
}
